import { render } from "./DealsSectionComponent.vue?vue&type=template&id=e77d765a&scoped=true"
import script from "./DealsSectionComponent.vue?vue&type=script&lang=js"
export * from "./DealsSectionComponent.vue?vue&type=script&lang=js"

import "./DealsSectionComponent.vue?vue&type=style&index=0&id=e77d765a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e77d765a"]])

export default __exports__